// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { CatalogueProductFragmentDoc } from '../../../graphql/api/product/catalogueProduct.fragment.generated';
import { WeddingRingLinkFragmentDoc } from '../../../router/fragments/weddingRingLink.fragment.generated';
import { MetalFilterMetalFragmentDoc } from '../../../graphql/api/product/rings/fragments/filters/metalFilter.fragment.generated';
import { MoneyFragmentDoc } from '../../../graphql/api/fragments/money.fragment.generated';
import { ProductGalleryFragmentDoc } from '../../../components/layout/gallery/ProductGallery.generated';
import { CatalogueVideoFragmentDoc } from '../../../graphql/api/product/catalogueVideo.fragment.generated';
import { ProductPageMetaFragmentDoc } from '../composables/useProductPageMeta.generated';
import { AccentGemFragmentDoc } from '../composables/useAccentGems.generated';
import { TaxSnippetFragmentDoc } from '../../../components/rings/TaxSnippet.generated';
import { RingSizeFragmentDoc } from '../../../graphql/api/product/rings/fragments/ringSize.fragment.generated';
import { RecommendedRingSizeFragmentDoc } from '../../../graphql/api/product/rings/fragments/recommendedRingSize.fragment.generated';
export const WeddingRingFragmentDoc = gql`
    fragment weddingRing on CatalogueWeddingRing {
  ...catalogueProduct
  ...productGallery
  ...productPageMeta
  video {
    ...catalogueVideo
  }
  accentGemItems {
    ...accentGem
  }
  categories {
    translation(locale: $locale) {
      name
    }
    systemCode
  }
  ringStyles {
    translation(locale: $locale) {
      name
    }
    systemCode
  }
  bandWidth
  bandThickness
  ...weddingRingLink
  variations {
    primaryMetal {
      ...metalFilterMetal
    }
    catalogueCode
    suffix
    productName
    ...weddingRingLink
  }
  translation(locale: $locale) {
    seoText
    description
  }
  salePrice(currency: $currency, country: $country) {
    total {
      ...money
    }
    ...taxSnippet
  }
  sizes(country: $country) {
    ... on RingSize {
      ...ringSize
    }
    ... on RecommendedRingSize {
      ...recommendedRingSize
    }
  }
}
    ${CatalogueProductFragmentDoc}
${ProductGalleryFragmentDoc}
${ProductPageMetaFragmentDoc}
${CatalogueVideoFragmentDoc}
${AccentGemFragmentDoc}
${WeddingRingLinkFragmentDoc}
${MetalFilterMetalFragmentDoc}
${MoneyFragmentDoc}
${TaxSnippetFragmentDoc}
${RingSizeFragmentDoc}
${RecommendedRingSizeFragmentDoc}`;